module.exports = __webpack_public_path__ + "static/media/logo2.a3b751b2.svg";